import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnSL: CultureInfo = {
  name: 'ff-Latn-SL',
  displayName: 'Pulaar (Latn, Seraa liyon)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-SL',
  parent: CultureInfoFfLatn
};
